import { TYPE_FACTURE } from '@/configuration/devisConf';

export default function aEncoreQuantiteDispo(affectation, quantiteDispo, type) {
  if (type === TYPE_FACTURE) return true;
  let totalQuantiteDispo = 0;
  affectation?.forEach((affectation) => {
    totalQuantiteDispo += affectation.quantiteDispo;
  });
  return totalQuantiteDispo < 1 && (totalQuantiteDispo + quantiteDispo) <= 1;
}
